import React, { useEffect, useState } from 'react';
import CustomerLayout from './CustomerLayout';
import SafeIcon from '../../common/SafeIcon';
import { Button } from '../../components/ui/Button';
import { useNavigate } from 'react-router-dom';
import supabase from '../../supabase/supabase';

export default function CustomerFavorites() {
  const navigate = useNavigate();
  const [favorites, setFavorites] = useState([]);
  const [barbers, setBarbers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    const fetchFavorites = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (user) {
          setUserId(user.id);
          const { data: profile } = await supabase
            .from('profiles_1740423033529')
            .select('favorite_barbers')
            .eq('id', user.id)
            .single();
            
          const favIds = profile?.favorite_barbers || [];
          setFavorites(favIds);

          if (favIds.length > 0) {
            const { data: barbersData } = await supabase
              .from('profiles_1740423033529')
              .select('id, full_name, rating, avatar_url, district')
              .in('id', favIds)
              .eq('role', 'barber');
            setBarbers(barbersData || []);
          }
        }
      } catch (err) {
        console.error("Error fetching favorites:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchFavorites();
  }, []);

  const toggleFavorite = async (e, barberId) => {
    e.stopPropagation();
    if (!userId) return;
    
    const newFavs = favorites.filter(id => id !== barberId);
    setFavorites(newFavs);
    setBarbers(barbers.filter(b => b.id !== barberId));
    
    await supabase.from('profiles_1740423033529').update({ favorite_barbers: newFavs }).eq('id', userId);
  };

  return (
    <CustomerLayout>
      <div className="p-6">
        <h1 className="text-2xl font-black text-brand-dark mb-6 tracking-tight">Saved Barbers</h1>
        
        {loading ? (
          <div className="text-center py-10 opacity-50 font-bold uppercase text-[10px] tracking-widest">Loading favorites...</div>
        ) : barbers.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-20 text-center animate-in fade-in">
            <div className="w-24 h-24 bg-red-50 text-red-500 rounded-full flex items-center justify-center mb-6">
              <SafeIcon name="Heart" className="text-4xl" />
            </div>
            <h2 className="text-xl font-black text-brand-dark tracking-tight mb-2">No Favorites Yet</h2>
            <p className="text-gray-500 text-sm font-medium mb-8 max-w-[250px]">
              Tap the heart icon on any barber's profile to save them for quick access later.
            </p>
            <Button onClick={() => navigate('/app')} variant="outline" className="w-full max-w-[200px]">
              Browse Barbers
            </Button>
          </div>
        ) : (
          <div className="space-y-4">
            {barbers.map(barber => (
              <div key={barber.id} className="bg-white p-4 rounded-2xl border border-gray-100 shadow-sm flex items-center gap-4 cursor-pointer hover:border-brand-primary transition-all group" onClick={() => navigate('/app/book', { state: { barberId: barber.id } })}>
                <img src={barber.avatar_url || `https://ui-avatars.com/api/?name=${barber.full_name}&background=0047FF&color=fff`} className="w-16 h-16 rounded-xl object-cover bg-brand-light" alt={barber.full_name} />
                <div className="flex-1">
                  <h4 className="font-bold text-brand-dark">{barber.full_name}</h4>
                  <div className="flex items-center gap-1 text-xs text-gray-400 mt-1 font-bold">
                    <SafeIcon name="Star" className="text-brand-accent fill-current" />
                    <span className="text-brand-dark mr-2">{barber.rating || '5.0'}</span>
                    <span className="uppercase tracking-widest">{barber.district || 'Islandwide'}</span>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <button 
                    onClick={(e) => toggleFavorite(e, barber.id)} 
                    className="p-2 rounded-full hover:bg-red-50 transition-colors"
                  >
                    <SafeIcon name="Heart" className="text-red-500 fill-current" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </CustomerLayout>
  );
}